import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {useRecoilValue} from 'recoil';

import {addComma} from '@/utils';
import {HomeKnewBrandCard, user} from '@/store';
import {doBookMark} from '@/services/magazine';

import styles from './styles.module.scss';

export default function KnewBrand() {
  const navigator = useNavigate();
  const {magazine, product} = useRecoilValue(HomeKnewBrandCard);
  const accessToken = useRecoilValue(user);
  const [isBookmark, setIsBook] = useState(false);
  const parser = new DOMParser();
  const parsed = parser.parseFromString(magazine.contents || '', 'text/html');

  const doLike = async ($event: React.MouseEvent<HTMLSpanElement>) => {
    $event.preventDefault();
    $event.stopPropagation();
    if (!accessToken) {
      navigator('/login', {
        state: {
          prevPath: `${location.pathname}${location.search}`,
        },
      });
      return;
    }
    await doBookMark(product.id, !isBookmark, accessToken);
    setIsBook(!isBookmark);
  };

  useEffect(() => {
    setIsBook(product.isBookmark);
  }, [product]);

  return (
    <div className={styles.wrapper}>
      {/* 매거진 */}
      <div
        className={styles.card}
        onClick={() =>
          navigator(
            `/${
              magazine.category === 'brands' ? 'knewbrands' : magazine.category
            }/${magazine.id}`,
            {
              state: {
                prev: 'home',
              },
            },
          )
        }>
        <div className={styles.imgWrapper}>
          <img src={magazine.imageUrl} />
        </div>
        <div className={styles.contents_title_wrapper}>
          <span className={styles.title}>{magazine.title}</span>
          <span className={`${styles.icon} stick-arrow-right-icon`}>
            &nbsp;
          </span>
        </div>
        <div className={styles.contents}>
          {parsed.getElementById('for-contents')?.textContent || ''}
        </div>
      </div>
      {/* 컬렉션 */}
      <div
        className={styles.list}
        onClick={() =>
          navigator(
            `/${product.category === 'popup' ? 'popup' : 'zip'}/${product.id}`,
            {
              state: {
                prev: 'home',
              },
            },
          )
        }>
        <div className={styles.imgWrapper}>
          <img src={product.imageUrl} />
        </div>
        <div className={styles.txtWrapper}>
          <div className={styles.collectionTitle}>{product.title}</div>
          <div className={styles.collectionSubTitle}>{product.subtitle}</div>
          <div className={styles.price}>
            {!!product?.discountNumber && product.discountNumber > 0 && (
              <span>{`${product.discountNumber}%`}</span>
            )}
            {addComma(Number(product.price))}
          </div>
        </div>
        <div className={styles.likeWrapper}>
          <span
            className={`${styles.likeIcon} ${isBookmark ? styles.filled : ''}`}
            onClick={($event: React.MouseEvent<HTMLSpanElement>) =>
              doLike($event)
            }></span>
        </div>
      </div>
    </div>
  );
}
